import { render, staticRenderFns } from "./BooksInInventory.vue?vue&type=template&id=3f705706&scoped=true&"
import script from "./BooksInInventory.vue?vue&type=script&lang=js&"
export * from "./BooksInInventory.vue?vue&type=script&lang=js&"
import style0 from "./BooksInInventory.vue?vue&type=style&index=0&id=3f705706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f705706",
  null
  
)

export default component.exports